import { CHOICE, CORE, DELUXE, ECONOMY, STANDARD } from 'core/constants/products'
import isPlanType from '../isPlanType'

const migratedStates = [
  'AZ',
  'FL',
  'GA',
  'IL',
  'IN',
  'MI',
  'NE',
  'TX',
  'WI',
  'AL',
  'AR',
  'MS',
  'NV',
  'OH',
  'TN',
  'WY',
  'WV',
  'DE',
  'KY',
  'LA',
  'OK',
  'ND',
  'IA'
]

function is1200Plan<T extends CorePlan>(plan: T, stateAcronym: string): boolean {
  const planIsFromMigratedState = migratedStates.includes(stateAcronym)
  const planHasProperType = isPlanType(plan, ECONOMY, CHOICE, STANDARD, DELUXE, CORE)

  return planIsFromMigratedState && planHasProperType
}

export default is1200Plan
